var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import ButtonGroup from '../button-group';
import Icon from '../icon';
import Styled from './style';
var DocumentPreview = /** @class */ (function (_super) {
    __extends(DocumentPreview, _super);
    function DocumentPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.showNextImage = function () {
            if (_this.state.currentIndex < _this.props.images.length - 1) {
                _this.setState({ currentIndex: _this.state.currentIndex + 1 });
            }
        };
        _this.showPreviousImage = function () {
            if (_this.state.currentIndex > 0) {
                _this.setState({ currentIndex: _this.state.currentIndex - 1 });
            }
        };
        _this.state = {
            currentIndex: 0,
        };
        return _this;
    }
    DocumentPreview.prototype.render = function () {
        var images = this.props.images;
        var currentIndex = this.state.currentIndex;
        var isLeftButtonDisabled = currentIndex < 1;
        var isRightButtonDisabled = currentIndex >= images.length - 1;
        return (React.createElement(Styled, { currentIndex: currentIndex },
            React.createElement("div", { className: "container" }, this.props.children),
            React.createElement("div", { className: "controls" },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { disabled: isLeftButtonDisabled, className: "previous", onClick: this.showPreviousImage },
                        React.createElement(Icon, { name: "arrow-left" })),
                    React.createElement(Button, { disabled: isRightButtonDisabled, className: "next", onClick: this.showNextImage },
                        React.createElement(Icon, { name: "arrow-right" }))))));
    };
    return DocumentPreview;
}(React.Component));
export default DocumentPreview;
//# sourceMappingURL=index.js.map